import { MailPlus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { setReturnTo } from "@/features/payment-methods/store/payment-method-form-slice";
import { useAppDispatch } from "@/store";
import { AppRoute } from "@/types/routes";

export const PaymentAccountEmpty = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const onProceed = () => {
    dispatch(setReturnTo(location.pathname));
    navigate(AppRoute.PAYMENT_METHODS_LIST);
  };

  return (
    <div
      data-test-id="payment-account-empty"
      className="flex flex-row gap-4 bg-background rounded-lg border p-4"
    >
      <div className="text-muted-foreground">
        <MailPlus className="h-6 w-6" />
      </div>
      <div className="flex-1">
        <h6 className="text-muted-foreground text-sm leading-relaxed font-semibold">
          {t("mileageReview_PaymentMethod")}
        </h6>

        <p className="text-sm leading-relaxed">
          {t("payment_account_none_set_up")}
        </p>

        <Button
          onClick={onProceed}
          variant="link"
          size="sm"
          className="underline p-0 font-normal h-auto"
        >
          {t("payment_account_set_up_link")}
        </Button>
      </div>
    </div>
  );
};
